export const USER_ROLES = Object.freeze({
    admin: 'ROLE_ADMIN',
    commercial: 'ROLE_COMMERCIAL',
    financial: 'ROLE_FINANCIAL',
    tech: 'ROLE_TECH',
    client: 'ROLE_CLIENT'
});

export const CAC_TYPE = Object.freeze({
    CROP: 1,
    NURSERY: 2,
    VISITS: 3,
    SETTINGS: 4,
    ALERTS: 5,
    RESOURCES: 6
});

export const WORK_IN_PROGRESS = 'Funzionalità in sviluppo';
export const CROP_REPORT = 'CROP REPORT';
export const NURSERY_REPORT = 'NURSERY REPORT';
export const CUSTOMER_VISITS = 'CUSTOMER VISITS';
export const RESOURCES = 'RESOURCES';
export const NEW_REPORT = 'NEW REPORT';
export const SOWING = 'Sowing';
export const SOWING_INFO = 'Sowing Info';
export const ROGUING_REMARKS = 'Roguing Remarks';
export const FLOWERING_DATES = 'Flowering Dates';
export const CR_ALERTS = 'CR-Alerts';
export const A = 'A';
export const B = 'B';
export const U = 'U';
export const OP = 'OP';
export const LINES = [A, B, U];
export const GENERAL = 'General';

export const FIRST_YEAR_OF_ACTIVITY = 2007;
export const MAX_NUMBER_OF_TECHFORMS = 200;

// Commong Strings
export const SAVE = 'Save';
export const CANCEL = 'Cancel';
export const CONFIRM = 'Confirm';
export const EDIT = 'Edit';
export const DELETE = 'Delete';
export const LOGOUT = 'Logout';
export const SETTINGS = 'Settings';
export const DOWNLOAD_CROP_APP = 'Download Crop Report App';
export const DOWNLOAD_NURSERY_APP = 'Download Nursery Report App';
export const DOWNLOAD_CUSTOMER_VISITS_APP = 'Download Customer Visits App';
export const DOWNLOAD_INVENTORY_APP = 'Download Inventory App';

// Report Characters
export const DEVELOPMENT = 'Development';
export const STANDING = 'Standing';
export const UNIFORMITY = 'Uniformity';
export const BOLTING = 'Bolting';
export const DISEASES_GRAVITY = 'Diseases Gravity';
export const DISEASES_DESCRIPTION = 'Diseases Description';
export const ESTIMATED_YIELD = 'Estimated Yield';
export const ESTIMATED_SEEDLINGS = 'Estimated seedlings';
export const POTENTIAL_YIELD = 'Potential Yield';
export const EST_YIELD = 'Est. Yield';
export const EST_SEEDLINGS = 'Est. Seedlings';
export const REMARKS = 'Remarks';

// Params
export const DEVELOP = 'Develop';
export const STAND = 'Stand';
export const BOLT = 'Bolt';
export const SANITY = 'Sanity';

export const HTTP_CODE = {
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    CONFLICT: 409,
    SERVER_ERROR: 500
};

export const SERVER_CODE_MAPPER = {
    400: 'Bad request data',
    401: 'Unauthorized user',
    404: 'Page not found',
    409: 'User already exists',
    500: 'Internal server error'
};

export const SORT_TYPE = {
    ASCENDANT: 'asc',
    DESCENDANT: 'desc'
};

export const TECHFORM_MAIN_FIELDS = {
    ZONE: {
        key: 'zoneCode',
        value: 'Zone'
    },
    CUSTOMER: {
        key: 'custCode',
        value: 'Customer'
    },
    SPECIES: {
        key: 'speciesCode',
        value: 'Species'
    },
    SECTOR: {
        key: 'sectorCode',
        value: 'Sector'
    },
    VARIETY: {
        key: 'varietyDesc',
        value: 'Variety'
    },
    GROWER: {
        key: 'growerName',
        value: 'Grower'
    }
};

export const TECHFORM_MAIN_FIELDS_VALUES = Object.values(TECHFORM_MAIN_FIELDS).map((e) => e.value);
export const TECHFORM_MAIN_FIELDS_KEYS = Object.values(TECHFORM_MAIN_FIELDS).map((e) => e.key);

export const TECHFORM_FILTER_FIELDS = TECHFORM_MAIN_FIELDS_VALUES.filter(
    (e) => e.value !== 'Sector'
);

export const ExtraReportCharacterNames = {
    NOTES: 'Notes',
    DESTROYED_REASON: 'DestroyedReason',
    DESTROYED_HA: 'DestroyedHa',
    NET_HA: 'NetHa',
    INDEMNITY: 'Indemnity',
    INFORMED_CUSTOMER: 'InformedCustomer'
};

export const HarvestValues = {
    S: 'Standard',
    F: 'Female-only',
    Y: 'F+M separate',
    X: 'F+M mixed'
};

export const OrganicValues = {
    E: 'Conventional',
    G: 'Organic'
};

export const TunnelValues = {
    P: 'Open Field',
    T: 'Tunnel'
};

export const FloweringDatesNames = {
    startFlowering: 'Start',
    startFullFlowering: 'Start Full',
    endFullFlowering: 'End Full',
    endFlowering: 'End',
    pinching: 'Pinching',
    harvesting: 'Harvesting'
};

export const FloweringDatesCharacterNames = {
    startFlowering: 'Start',
    startFullFlowering: 'StartFull',
    endFlowering: 'End',
    endFullFlowering: 'EndFull',
    pinching: 'PinchingDates',
    harvesting: 'HarvestingDates'
};

export const ReportCharactersNames = {
    stand: STAND,
    develop: DEVELOP,
    uniform: 'Uniformity',
    bolt: BOLT,
    diseasesDescription: 'DiseasesDescription',
    diseasesGravity: 'DiseasesGravity',
    remarks: 'Remarks',
    roguing: 'RoguingRemarks',
    expYield: 'Yield',
    harvestData: 'HarvestData'
};

export const UNIFORMITY_VALUES = { 'No': '0', 'Yes': '1' };

export const DISEASES_GRAVITY_VALUES = [
    { value: 0, label: '0 - No Diseases' },
    { value: 1, label: '1 - High' },
    { value: 2, label: '2 - Medium' },
    { value: 3, label: '3 - Low' }
];

export const REPORT_CHARACTERS_NUMERIC_BOUNDS = {
    max: 100,
    min: 0
};

export const NUMERIC_VALUE_TOO_HIGH = `Max value is ${REPORT_CHARACTERS_NUMERIC_BOUNDS.max}`;
export const NUMERIC_VALUE_TOO_LOW = `Minimum value is ${REPORT_CHARACTERS_NUMERIC_BOUNDS.min}`;



// Photo types organized by groups
// Note that Line U remains in the API but we never show it as it has been deprecated
export const PHOTO_TYPE_GROUPS = [
    {
        groupName: 'Standard Photos',
        types: [
            {
                name: 'Landscape',
                value: '1'
            },
            {
                name: 'Diseases',
                value: '4'
            }
        ]
    },
    {
        groupName: 'General Line Photos',
        types: [
            {
                name: 'Off Type OP',
                value: '10'
            },
            {
                name: 'Line OP',
                value: '9'
            }
        ]
    },
    {
        groupName: 'Line F Photos',
        types: [
            {
                name: 'Off Type F',
                value: '7'
            },
            {
                name: 'Line F',
                value: '2'
            }
        ]
    },
    {
        groupName: 'Line M Photos',
        types: [
            {
                name: 'Off Type M',
                value: '8'
            },
            {
                name: 'Line M',
                value: '3'
            }
        ]
    }
];

export const APP_DOWNLOADS = {
    CROP: 'https://cropreport.cacseeds.it/crsandroid/index.html',
    NURSERY: 'https://cropreport.cacseeds.it/ncrsandroid/index.html',
    CUSTOMER_VISITS: 'https://cropreport.cacseeds.it/visitsandroid/index.html',
    INVENTORY: 'https://cropreport.cacseeds.it/inventoryandroid/index.html'
};
